import { Box, Typography } from '@mui/material';
import { FC, ReactNode } from 'react';


interface ITabPanelProps {
  children?: ReactNode,
  value: number,
  index: number,
}

export const TabPanel: FC<ITabPanelProps> = ({
  children,
  value,
  index
}) => {

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
    >
      {value === index && (
        <Box
          sx={{
            padding: "24px 0 10px 0",
            "@media screen and (max-width: 550px)": {
              padding: "10px 0 10px 0",
            },
          }}
        >
          <Typography component="div">{children}</Typography>
        </Box>
      )}
    </div>
  );
};
